import type Phaser from 'phaser';
import { CAMPAIGN_LEVELS } from '../../content/levels/campaign';
import { allowedMowers } from '../../content/levelSchema';
import type { Featured, GhostResponse } from '../../meta/online/schema';
import type { BoardsData } from './BoardsScene';
import type { LevelCardData } from './LevelCardScene';
import { wipeTo } from './WipeScene';

/**
 * The week's featured lawn (docs/ONLINE.md, "Boards"): its card, with the player's own mowers that
 * the lawn allows, whether or not they have reached it in the campaign (or bought the full game).
 * A clear goes on the featured board and pays no campaign rewards. `ghost`: the leader's run, to
 * race. BACK and DONE return to the featured board.
 */
export function playFeatured(
  scene: Phaser.Scene,
  featured: Featured,
  ghost: GhostResponse | null = null,
): void {
  const level = CAMPAIGN_LEVELS[featured.lawn - 1];
  if (!level) return;
  const backData: BoardsData = { open: 'featured' };
  const data: LevelCardData = {
    level,
    choices: allowedMowers(level.mowerRule),
    mowerHeading: 'ANY OF YOUR MOWERS',
    playlist: {
      kind: 'test',
      short: 'Weekly',
      levels: [level],
      index: 0,
      back: { scene: 'Boards', label: 'Boards', data: backData },
      featured: { week: featured.week, lawn: featured.lawn },
    },
    backTo: 'Boards',
    backData,
    ...(ghost
      ? { ghost: { run: ghost.run, name: ghost.name, ticks: ghost.value, kind: 'leader' as const } }
      : {}),
  };
  wipeTo(scene, 'LevelCard', data);
}
